import { useEffect } from "react";

import { Box } from "@chakra-ui/react";
import { IIndividualAccount } from "api/individual-user-management/types";
import { ReactComponent as IconCopy } from "assets/icons/copy.svg";
import { useIndividuals } from "contexts/individuals-context";
import copy from "copy-to-clipboard";
import { accountColumns } from "features/individuals/individuals/individuals-list-table/const";
// import {
//   IIndividualListData,
//   ISelectedAccountListData,
// } from "features/individuals/individuals/individuals-list-table/types";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "routes/constants";
import { formatDateToDDMMYYTTSS, handleAmountFormat } from "utils";
import { ONE_NAIRA_IN_KOBO, ZERO } from "utils/constants";
import { Maybe } from "utils/general/maybe";

import { customSuccessToast } from "ui/custom-toast";
import { Spinner } from "ui/spinner";
import { Status } from "ui/status";
import { activeTextToStatus, statusToActiveText } from "ui/status/const";
import Table from "ui/table";
import TableWrapper from "ui/table/table-wrapper";
import { TTableRowData } from "ui/table/types";
import { Heading3, Paragraph3 } from "ui/typography";
import { Heading4, Paragraph4 } from "ui/typography";

import { MoreQuickActions } from "./more-quick-actions";

// import { TableHeaderCTAs } from "./TableHeaderCTAs";

// import { IIndividualListTableProps } from "./types";
const copyText = (text: string) => {
  if (text === "" || text === "N/A") return;
  copy(text);
  customSuccessToast({ message: `Copied: ${text}` });
};

const SelectedAccount = () => {
  const {
    handleGetIndividualAccounts,
    individualAccountsData: individualDetails,
    isLoadingIndividualAccounts,
  } = useIndividuals();
  const navigate = useNavigate();
  const { individualId } = useParams();

  const handleViewIndividualDetails = (individualRowData: TTableRowData) => {
    const individualId = individualRowData["id"] as string;
    navigate(
      `${ROUTES.INDIVIDUALS_PAGE}/account/${individualId}/view-transactions`
      // `${ROUTES.INDIVIDUALS_PAGE}/account/${individualId}/view-transactions/${walletId}`
    );
  };

  const [yieldEarnedNaira, yieldEarnedKobo] = handleAmountFormat({
    value: String(individualDetails?.totalBalance / ONE_NAIRA_IN_KOBO),
    includeNairaSymbol: true,
    shouldFormatZero: true,
  }).split(".");

  const formattedData = individualDetails?.data?.map(
    (account: IIndividualAccount, idx: number) => {
      const {
        id,
        accountName,
        accountNumber,
        balance,
        createdAt,
        status,
        pnd,
      } = account;
      const individualActiveStatus = activeTextToStatus[status];
      const wId = individualDetails?.data?.[idx]?.walletId;

      return {
        "Account Name": (
          <Box className="flex items-center gap-3">
            <Box>
              <Heading4
                fontSize="14px"
                fontWeight="600"
                lineHeight="20px"
                textColor="#09090B"
              >
                {accountName}
              </Heading4>
            </Box>
          </Box>
        ),
        "Account Number": (
          <Box className="flex gap-2 items-center">
            <Paragraph4
              fontSize="14px"
              lineHeight="16px"
              textColor="#101828"
            >
              {accountNumber}
            </Paragraph4>
            <IconCopy
              onClick={() => copyText(`${accountNumber}`)}
              className="ml-1 cursor-pointer"
            />
          </Box>
        ),
        Balance: (
          <Box className="individualTableColumnCss">
            {/* {formatAmountIntoOrdinaryDecimalAndNaira(balance)} */}
            {balance >= ZERO
              ? handleAmountFormat({
                  value: String(balance / ONE_NAIRA_IN_KOBO),
                  includeNairaSymbol: true,
                  shouldFormatZero: true,
                })
              : "N/A"}
          </Box>
        ),
        Status: (
          <Status
            status={status === "frozen" ? "error" : individualActiveStatus}
            text={
              status === "frozen"
                ? "inactive"
                : statusToActiveText[individualActiveStatus]
            }
            className="w-fit"
          />
        ),
        "Freeze Status": (
          <Box className="flex w-full items-center">{pnd ? "Frozen" : "-"}</Box>
        ),
        "Date Created": (
          <Box>{createdAt ? formatDateToDDMMYYTTSS(createdAt) : "N/A"}</Box>
        ),

        "": (
          <>
            <MoreQuickActions
              individualDetails={individualDetails}
              handleViewIndividualDetails={handleViewIndividualDetails}
              walletId={wId}
            />
          </>
        ),
        id,
      };
    }
  );

  useEffect(() => {
    if (!individualId) return;
    handleGetIndividualAccounts({ userId: individualId });
  }, [individualId]);

  return (
    <Box>
      <Box className="flex flex-col mb-2 gap-1 px-6 pt-5 pb-4  rounded-[20px] bg-white justify-start">
        <Paragraph3
          lineHeight="14px"
          textColor="#718096"
          fontWeight="400"
        >
          Account Balance
        </Paragraph3>
        <Maybe condition={isLoadingIndividualAccounts}>
          <Spinner size="20px" />
        </Maybe>
        <Maybe condition={!isLoadingIndividualAccounts}>
          <Heading3
            lineHeight="20px"
            fontWeight="700"
            textColor="#1A202C"
          >
            {yieldEarnedNaira}.
            <span className="text-sm font-[700]">
              {yieldEarnedKobo || "00"}
            </span>
          </Heading3>
        </Maybe>
      </Box>
      <TableWrapper className="!p-0">
        <Table
          columns={accountColumns}
          data={formattedData}
          hasCheckbox
          isLoading={isLoadingIndividualAccounts}
        />
      </TableWrapper>
    </Box>
  );
};

export default SelectedAccount;
